import {useRef, useCallback} from 'react';

const useOnClickOff = (onClickOff) => {
  const nodeRef = useRef();
  function handleClickOutside(event) {
    if (nodeRef.current && !nodeRef.current.contains(event.target)) {
      onClickOff(event);
    }
  }
  return useCallback((node) => {
    nodeRef.current = node;
    if (node) {
      document.addEventListener('mouseup', handleClickOutside);
    } else {
      document.removeEventListener('mouseup', handleClickOutside);
    }
  }, []);
};

export default useOnClickOff;
